import { localStorageKey } from '../../../common/utils/constant';
import { COMMON_TRACK_COLLECTION_CHANGE } from './constants';

export function trackCollectionChange(args) {
  console.log('WARN: trackCollectionChange');
  let updatedCollections = localStorage.getItem(localStorageKey.UPDATE_COLLECTION);
  updatedCollections = JSON.parse(updatedCollections);
  const newData = [];
  const { uuid } = args;

  if (uuid) {
    newData.push(uuid);
  }

  if (!updatedCollections || !updatedCollections.length)
    localStorage.setItem(localStorageKey.UPDATE_COLLECTION, JSON.stringify(newData));
  else {
    updatedCollections = [...new Set([...updatedCollections, ...newData])];
    localStorage.setItem(localStorageKey.UPDATE_COLLECTION, JSON.stringify(updatedCollections));
  }
  return {
    type: COMMON_TRACK_COLLECTION_CHANGE,
    data: updatedCollections,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_TRACK_COLLECTION_CHANGE:
      return {
        ...state,
        updatedCollections: action.data,
      };

    default:
      return state;
  }
}
